export default {
	text: {
		addButton: 'Toevoegen',
		addFile: 'Bestand toevoegen',
		addAdInfo: 'Voeg extra informatie toe',
		addedFrom: 'Toegevoegd door ',
		approveRequestButtonInfo: 'Verzoek goedkeuren',
		area: 'Gebied',
		areaAssociation: '',
		all: 'Allen',
		approvalStateItems: {
			created: 'Gemaakt',
			openForApproval: 'Aangevraagd',
			editing: 'In behandeling',
			approved: 'Goedgekeurd',
			declined: 'Afgewezen',
			canceled: 'Afgelast',
		},
		allowedFormats: {
			jpg: 'JPEG-bestand (.jpeg, .jpg)',
			png: 'PNG-bestand (.png)',
			html: 'HTML-bestand (.html)',
			pdf: 'PDF-bestand(.pdf)',
			doc: 'Word-Document (.doc, .docx)',
			xls: 'Excel-tabel (.xls)',
			txt: 'Text-bestand (.txt)',
		},
		attachmentType: {
			text: 'tekst',
			file: 'bestand',
			link: 'link',
		},
		abortNoSave: 'Annuleren zonder op te slaan',
		abort: 'Annuleren',
		adjustDef: 'Pas definities aan',
		additionalFilter: 'Geavanceerde filters',
		additionalConactInfo: 'Aanvullende contactgegevens',
		additionaltInfo: 'Extra informatie',
		additionalConactInfoPlaceholder: 'bv. tweede contactpersoon, beschikbaarheidstijd, enz...',
		addStreet: 'Straat',
		approval: 'Goedkeuring',
		approve: 'Goedgekeurd',
		approceDecline: 'Goedkeuren/Afwijzen',
		apply: 'Registreren',
		bestPerfOnly: 'Alleen beste prestatie per atleet',
		backButton: 'Terug',
		bestlist: 'Ranglijst',
		bestlistTitle: 'Ranglijsten',
		bestListsLoading: 'Ranglijsten laden',
		bestResult: 'Resultaat',
		backToOverview: 'Naar overzicht',
		category: 'Categorie',
		confirmTitle: 'Bevestigen',
		confirmation: 'Uw account is succesvol geverifieerd. U kunt nu inloggen',
		confirmPassword: 'Bevestig wachtwoord',
		createButton: 'Creëren',
		createAndNew: 'Opslaan en nieuw',
		createAndClose: 'Opslaan en sluiten',
		createAndNext: 'Opslaan en doorgaan',
		createCustom: 'Zelf creëren',
		createApprovalHint1: 'Door het bericht te verzenden, bevestigt de organisator kennis te hebben genomen van de <a href="https://www.dlv-event.de/Files/event-info.pdf" target="_blank">Hinweise</a> und verpflichtet sich zu Beachtung der dort angegebenen Auflagen sowie zur Einhaltung der DLV-Satzung und Ordnung, der darin enthaltenen DLV-Anti-Doping-Codes (ADC), der Deutschen Leichtathletikordnung (DLO), der Gebührenordnung (GBO) sowie zur Einhaltung der Internationalen Wettkampfregeln (IWR). Der Veranstalter verpflichtet sich des Weiteren, Teilnehmer seiner Veranstaltung schriftlich darauf hinzuweisen, dass dieser mir der Teilnahme die Geltungen des DLV-Anti-Doping-Codes (DLV-ADC) anerkennt und sich dessen Bestimmungen unterwirft. ',
		createApprovalHint2: 'Er erklärt sich auch damit einverstanden, dass vorgenannte Veranstaltung einschließlich der genannten Kontaktdaten in den DLV- und LV-Publikationen, sowie den Internetseiten www.leichthletik.de, www.laufen.de (nur Laufveranstaltungen) und des eigenen LV veröffentlicht werden kann, Dieses gilt auch für die Ergebnisse zur Erstellung von Bestenlisten.',
		createApprovalHint3: 'Hier können Sie Ausschreibung, Zeitplan und Ergebnislisten hochladen.',
		createApprovalHint4: 'Hierfür klicken Sie auf „Datei hinzufügen“ und wählen dann aus, ob Sie einen Link auf der Homepage eingeben, oder eine Datei hochladen wollen. Dann füllen Sie alle 4 offenen Felder aus. „Titel“ – so heißt die Datei/Link bei Veröffentlichung im Internet, unter „Gruppe“ wählen Sie das Themengebiet zu dem die Datei/Link gehört, „Sort“ steht für die Sortierreihenfolge in der die Daten/Links angezeigt werden sollen (1 = an erster Stelle usw.). Bei „Link“ tragen Sie den Link zu einer Homepage ein, bei „Datei“ laden Sie über „Durchsuchen“ eine Datei von Ihrem PC hoch oder bei „Text“ geben Sie den gewünschten Fließtext ein.',
		createApprovalHint5: 'Erlaubte Dateiformate sind:',
		compApprovalFinisherHint1: 'Voer hier de algemene informatie (over alle onderdelen en baanlengtes) van uw evenement in:',
		compApprovalFinisherHint2: 'Eenmaal geregistreerd, kunnen de finishernummers alleen worden gewijzigd door de {LV}!',
		compApprovalFinisherHint3: 'Voer hier het totale aantal van uw evenement in:',
		compApprovalFinisherHint4: 'Naar welk adres moet de factuur worden gestuurd?',
		createTime: 'Aanmaakdatum',
		competitionContact: 'contact opnemen met de wedstrijd',
		class: 'Categorie',
		cancel: 'Afgelast',
		classes: 'categorieën',
		classesSelected: 'Categorieën geselecteerd',
		closingDate: 'Registratie deadline',
		checkingLoading: 'Controleer laadproces',
		checkingTitle: 'Controle',
		competition: 'Wedstrijd',
		createdFrom: 'Geregistreerd door',
		createdOn: 'Opgenomen op de',
		copy: 'Kopiëren',
		copyFrom: 'Kopiëren van',
		competitionId: 'WED-ID',
		competitionNotPassed: 'De wedstrijd is nog niet voorbij',
		competitionFinisherRecorded: 'Finish-nummers zijn al geregistreerd',
		competitionLocation: 'Wedstrijdlocatie',
		compApprovalBillingInfo: 'Sind Sie ein gemeinnütziger Veranstalter und werden alle Einnahmen aus Start/-Teilnehmergebühren der Veranstaltung unmittelbar mildtätigen Zwecken im Sinne von §53 AO, §4 Nr. 18 UStG zugeführt?',
		compApprovalBillingUsage: 'Geef een liefdadig doel aan',
		compApprovalFeeInfo: 'Er worden inschrijf-/deelnamekosten in rekening gebracht',
		competitionApprovalRequest: 'Wedstrijd aanmaken',
		company: 'Bedrijf',
		competitionApproval: 'Wedstrijdvergunning',
		competitionApprovalType: {
			all: ' Stadionweg - iedereen',
			nonStadiaMeasured: 'Stadionfern - vermessen',
			nonStadiaNonMeasured: 'Stadionfern - nicht vermessen',
			nonStadiaMixedMeasured: 'Stadionfern - gemischt',
		},
		competitionApprovalArt: {
			streetRun: 'Straßen-/Landschaftslauf',
			crossCountry: 'Cross',
			mountainRun: 'trailrunning',
			streetWalk: 'hardloopevenementen',
			else: 'Anderen (bv. trail, adventure run, duathlon ...)',
			peoplesRun: 'Kinderrun',
		},
		competitionGroups: {
			w: 'Vrouwen',
			m: 'Mannen',
			w20: 'VU20/U18',
			m20: 'MU20/U18',
			w16: 'VU16/U14',
			m16: 'MU16/U14',
			w12: 'VU12 en jonger',
			m12: 'MU12 en jonger',
			wsen: 'Vrouwen Senioren',
			msen: 'Mannen Senioren',
			sumRun: 'Waarvan lopers',
			sumInline: 'Welk nummer anders (vb.: Inline, wandelen, ...)',
			sumNordic: 'Inclusief aantal (Nordic) wandelaars',
		},
		competitionApprovalTitle: 'Goedgekeurde wedstrijd',
		competitionApprovalCategorryArt: 'Categorie en kunst',
		competitionApprovalEvClMatrix: 'Onderdeel categorie combinaties',
		competitionApprovalEventClass: 'Categorie en wedstrijden',
		competitionApprovalAttachments: 'Bestanden en links',
		competitionApprovalDetailView: 'Evenement details',
		competitionLoading: 'Wedstrijd wordt geladen',
		competitionTitle: 'Wedstrijd',
		competitionCategory: {
			free4all: '00.0 Breitensport',
			club_Sportfest: '1.1 Sportfest vereinsoffen',
			area_Championship: '2.1 Kreismeisterschaft',
			area_Sportfest: '2.2 Sportfest kreisoffen',
			district_Championship: '3.1 Bezirksmeisterschaft',
			district_Sportfest: '3.2 Sportfest bezirksoffen',
			region_Championship: '4.1 Landesmeisterschaft',
			region_Sportfest: '4.2 Sportfest landesoffen',
			region_Sportfest_Bordering: '4.4 Sportfest landesoffen + 1 weiterer LV',
			national_Championship: '5.1 Deutsche Meisterschaft',
			national_Sportfest: '5.2 Sportfest national',
			national_Invitational: '5.3 Einladungssportfest national',
			national_Runevent: '5.4 Nationale Laufveranstaltung',
			international_InvitationalWalking: '6.4 Einladungssportfest Gehen',
			international_Runevent: '6.6 Internationale Laufveranstaltung',
			iAAF_Runevent: '8.3 Internationale Laufveranstaltung mit EA- oder WA-LABEL',
		},
		createInvoice: 'Maak een rekening',
		courseLength: 'Routelengte',
		competitor: 'Atleet',
		gerCompetitionId: 'Deutsche Wettkampfnummer',
		club: 'Vereniging',
		country: 'Land',
		customEvents: 'Eigen wedstrijden',
		customEventLabels: {
			run: 'Hardlopen',
			walk: 'Wandelen',
			nordicWalking: 'Nordic Walking',
			mixedWalking: 'Walking/Nordic Walking (zelfde trajectlengte)',
			hiking: 'Wandeltocht',
			inlineSkating: 'Inline Skating',
			wheelChair: 'Rollschaatsen',
			timeRun: 'Ren op tijd',
			else: 'Anderen',
		},
		dialogText: {
			reallySave: 'Weet je zeker dat je het wilt Opslaan?',
			uSure: 'Weet je het zeker?',
		},
		dialog: 'Dialoog',
		dashboardTitle: 'LA.Portal Service',
		dashboard: 'LA.Portal Service',
		deleteRolesButton: 'Verwijderen',
		delete: 'Verwijderen',
		deleteRequest: 'Zeker verwijderen?',
		details: 'Details',
		dateFrom: 'Datum van',
		dateTo: 'Datum tot',
		download: 'Downloaden',
		dob: 'Geboortedatum',
		declinePerf: 'Prestaties voor leaderboards verlagen',
		declineChecking: 'Afwijzen',
		district: 'Gebied',
		differentRoute: 'Ander adres',
		date: 'Datum',
		districtAssociation: 'Bezirksverband',
		duration: 'Duur',
		eventType: {
			genericRun: 'Hardlopen', // Single
			verticalJump: 'Hoogspringen', // Single
			horizontalJump: 'Verspringen', // Single
			throw: 'Werp', // Single
			multi: 'Meerkamp', // Multi
			endurance: 'Uithoudingsvermogen', // Endurance
			dmm: 'Deutsche Mannschaftsmeisterschaft',
			cup: 'Beker',
			children: 'Kinderleichtathletik',
			multiTeam: 'Mehrkampf-Mannschaft',
			sprintRun: 'Sprint',
			roundRun: 'Ronde',
			hurdleRun: 'Hordelopen',
			multiCup: 'SVM-Mehrkampf',
			enduranceTeam: 'Estafette team',
		},
		eventlocation: 'Locatie',
		editTime: 'Datum aanpassen',
		email: 'E-mail',
		endAge: 'Einde leeftijd',
		endDate: 'Eind datum',
		environment: 'Omgeving',
		errorInvalidInput: 'Invoer ongeldig',
		errorEmpty: 'Mag niet leeg zijn',
		errorFirstNameRequired: 'Voornaam is verplicht',
		errorLastNameRequired: 'Achternaam is verplicht',
		errorEmailRequired: 'E-mail is vereist',
		errorEndBeforeStart: 'De einddatum mag niet voor de startdatum liggen',
		errorEventTooLong: 'Het evenement mag niet langer duren dan 100 dagen',
		errorStartDateInvalid: 'De startdatum is ongeldig',
		errorInvalidEmail: 'Het e-mail adres is ongeldig',
		errorPasswordRequired: 'Wachtwoord is vereist',
		errorConfirmPasswordRequired: 'Een wachtwoord is verplicht',
		errorLanguageRequired: 'Taal is vereist',
		errorOrganizationRequired: 'Organisatie is verplicht',
		errorRoleRequired: 'Rol is verplicht',
		errorReasonRequired: 'Reden is vereist',
		errorUserRequired: 'Gebruiker vereist',
		errorNameRequired: 'Naam is verplicht',
		errorCompetitorRequired: 'Deelnemers vereist',
		errorBestResultRequired: 'Resultaat vereist',
		errorShouldBeTime: 'Invoer komt niet overeen met het juiste formaat (00: 00: 00.00)',
		errorShouldBeDecimal: 'Invoer komt niet overeen met het juiste formaat (+/- 00.00)',
		errorShouldBeNumber: 'Invoer komt niet overeen met het juiste formaat (+0000)',
		errorClassDefRequired: 'Categorie verplicht',
		errorEventRequired: 'Onderdeel vereist',
		errorResultDate: 'Datum benodigd',
		errorCompetitionRequired: 'Competitie vereist',
		errorNationRequired: 'Nationaliteit vereist',
		errorEnvironmentRequired: 'Omgeving vereist',
		errorTownRequired: 'Stad vereist',
		error404: 'Opgevraagde gegevens niet gevonden, controleer de juistheid van de ingevoerde gegevens',
		error403: 'U heeft geen toegang tot deze bron',
		error400: 'Onjuiste gegevens, controleer of de gegevens correct zijn',
		error422: 'Gegevens die niet kunnen worden verwerkt, controleer de door u verstrekte gegevens',
		error500: 'Server werkt niet, neem contact op met de beheerder',
		errorDateFromRequired: 'Voer datum in',
		errorDateToRequired: 'Voer datum in',
		errorMinZero: 'Mag niet kleiner zijn dan 0',
		errorMinOne: 'Mag niet kleinder zijn dan 1',
		errorMax12: 'Mag niet groter dan 12 zijn',
		errorMax31: 'Mag niet groter dan 31 zijn',
		errorSum: 'De sommen van beide items moeten overeenkomen',
		errorInvalidUrl: 'Adres is niet geldig',
		expandButton: 'Alles uitvouwen',
		editCompApprovalREQUEST: 'De wedstrijd is al goedgekeurd. Bewerken kan ertoe leiden dat hij deze status verliest. Weet je zeker dat je door wilt gaan?',
		editCompApprovalHINT: 'Er zijn wijzigingen aangebracht waardoor de vergunning vervalt. Weet je zeker dat je ze wilt opslaan?',
		editCompApprovalDeleteHINT: 'Weet je zeker dat je de wedstrijd wilt verwijderen? Deze stap kan niet worden teruggedraaid!',
		event: 'Onderdeel',
		eventRegistration: 'Registratie',
		events: 'Wedstrijd',
		eventMaxPeople: 'Maximum aanntal deelnemers',
		eventsSelected: 'Competities geselecteerd',
		eventClassDef: 'Wedstrijd/categorie-definitie',
		edit: 'Aanpassen',
		editLow: 'aanpassen',
		editedFrom: 'Laatst gewijzigd door',
		fax: 'Fax',
		fileTitle: 'Titel',
		fileSort: 'Sorteren',
		fileGroup: 'Groep',
		firstTimeEvent: 'Eerste onderdeel',
		from: 'van',
		forgotPasswordTitle: 'Wachtwoord vergeten',
		forgotPasswordButton: 'Wachtwoord vergeten',
		forgotPasswordSuccess: 'Controleer uw e-mail om uw wachtwoord opnieuw in te stellen.',
		firstName: 'Voornaam',
		filterButton: 'Filter',
		finishButton: 'Klaar',
		finisherNumbers: 'Recordaantallen van finishers',
		fromDlo: 'nach DLO',
		fromPreset: 'Kopieren van ander recordlijst',
		fileGroups: {
			tender: 'Inschrijving',
			online: 'Online aanmelden',
			schedule: 'Tijdschema',
			entries: 'Deelnemer',
			infos: 'Overige informatie',
			else: 'Andere',
			live: 'live-resultaten',
			results: 'Resultaten',
			moreLA: 'Meer op....atletiek.nl',
			elseLA: 'Andere...atletiek.nl',
			liveOwner: 'Live resultaten',
			resultsOwner: 'Resultaten',
		},
		foreignerfilter: 'Te exporteren diensten',
		foreigners_all: 'Allemaal',
		foreigners_noforeigner: 'Alleen in aanmerking voor de ranglijst',
		foreigners_onlyforeigner: 'Niet opgenomen in de ranglijst',
		gps1: 'GPS (Lat)',
		gps2: 'GPS (Lng)',
		genderLable: 'Geslacht',
		gender: {
			m: 'Mannelijk',
			f: 'Vrouwelijk',
			mixed: 'Mixed',
		},
		generate_invoice: 'Factuur genereren',
		handTime: 'Handtijden',
		headerHash: '#',
		headerCreatedAt: 'Gemaakt in',
		headerChangedAt: 'Gewijzigd om',
		headerOrganization: 'Organisatie',
		headerUser: 'Gebruiker',
		headerCompetitor: 'Atleet',
		headerCompetitionName: 'Wedstrijdnaam',
		headerCompetitionLocation: 'Wedstrijd locatie',
		headerCompetitionDate: 'Wedstrijd data',
		headerContactAddress: 'Contactadres voor de wedstrijd (wordt gepubliceerd)',
		headerRole: 'Rol',
		headerStatus: 'Status',
		headerReason: 'Reden',
		headerActions: 'Actie',
		headerOrganizationName: 'Organisatie naam',
		headerBestlistName: 'Naam',
		headerRegionalRestriction: 'Regionale-Einschränkung',
		headerPerfListName: 'Naam van de lijst met services',
		headerBestResult: 'Resultaat',
		headerBestWind: 'Wind',
		headerEventShortNational: 'Wedstrijd',
		headerHeightWeight: 'Zonder gewicht',
		headerPerformanceDateTime: 'Datum',
		headerPerformanceCompetitionName: 'Wedstrijd',
		headerPerformanceCompetitionTown: 'Plaats',
		headerPerformanceOrganizationName: 'Vereniging',
		headerPerformanceCreatorUser: 'Bron',
		headerStatisticData: 'Statische gegevens',
		headerName: 'Naam',
		headerYob: 'Jaar',
		headerDateFrom: 'Datum van',
		headerDateTo: 'Datum tot',
		headerTown: 'Stad',
		headerLocation: 'Wedstrijd locatie',
		headerNation: 'Land',
		headerArea: 'Provincie',
		headerDistrict: 'Provincie',
		headerStateCode: 'LV-Kürzel',
		heightWeight: 'geen gewicht',
		homepage: 'Website',
		handtime: 'Handtijd',
		hintNeedProtocol: 'Vergeet niet het meetprotocol van elke wedstrijd mee te sturen!',
		hintMustAgree: 'Door je te registreren ga je akkoord met de gebruiksvoorwaarden en het bezorgen van dienstrelevante e-mails.',
		hintNewsletter: 'Ja, ik ontvang graag productnieuws en ander interessant nieuws in de nieuwsbrief.',
		indoor: 'Indoor',
		inMeter: 'in Meter',
		inKMeter: 'in KM',
		invoice: 'Factuur',
		invoiceDate: 'Factuur datum',
		insertCompetition: 'Goedkeuring aanvragen',
		insertSearchText: 'Voer tekst in om te beginnen met zoeken',
		kind: 'Art',
		km: 'km',
		lastEditedOn: 'Laatst bewerkt op',
		location: 'Plaats',
		loginTitle: 'Inloggen',
		login: 'Aanmelden',
		license: 'Licentie',
		logout: 'Uitloggen',
		loginButton: 'Aanmelden',
		lastName: 'Achternaam',
		language: 'Taal',
		licenseTitle: 'Licentie',
		measurementProtocol: 'Meetprotocol',
		licenseButton: 'Downloaden',
		masterorganization: 'overkoppelde organisatie',
		multiRecordLable: 'Geleverd binnen een meerkamp wedstrijd',
		mr: 'Man',
		mrs: 'Vrouw',
		mob: 'Geboortemaand',
		mobile: 'Mobiel',
		noButton: 'Nee',
		next: 'Volgende',
		none: 'Geen',
		noDataFound: 'Geen data gevonden',
		newAccount: 'Maak een nieuw account aan',
		newPerformance: 'Nieuwe prestatie',
		newRequestButton: 'Nieuw verzoek',
		newBestList: 'Nieuwe ranglijst',
		newCompetitionApproval: 'Nieuwe wedstrijd',
		newCompetitionApprovalTitle: 'Nieuwe wedstrijd',
		newRoleButton: 'Nieuwe rol',
		newUserRoleTitle: 'Nieuwe gebruikersrol',
		newRoleRequestTitle: 'Nieuwe rolvereiste',
		newRoleRequestAdminInfo: 'Deze organisatie heeft geen beheerder. Vraag nu beheerdersrechten aan of neem contact op met de vereniging voor hulp',
		newBestListTitle: 'Nieuwe ranglijsten',
		newPerformanceInfo: 'Nieuwe service is gemaakt',
		newChecking: 'Nieuw ...',
		newCheckingTitle: 'Nieuw...',
		newCompetitionTitle: 'nieuwe wedstrijd',
		newCompetition: 'Nieuwe wedstrijd',
		newPerformanceTitle: 'Nieuwe prestatie',
		notDecidedChecking: 'Als negatief markeren',
		negativeChecking: 'Markeren als niet besloten',
		nationalAthleteCode: 'Nationale atletencode',
		name: 'Naam',
		messageSent: 'Bericht verzonden',
		nation: 'Nationaliteit',
		outdoor: 'Outdoor',
		organization: 'Organisatie',
		organisator: 'organisator',
		organizationName: 'Vereniging/ organisatie',
		on: ' bij de ',
		otherContact: 'voer een ander adres in',
		ok: 'OK',
		originCountry: 'Land van herkomst',
		place: 'Plaats',
		zip: 'Postcode',
		password: 'Wachtwoord',
		perfTime: 'Prestatiedatum',
		performance: 'Resultaten',
		performanceTitle: 'Resultaten',
		performanceLoading: 'Resultaten worden geladen',
		performanceList: 'Prestatielijst',
		points: 'Punten',
		phone: 'Telefoon',
		protocollAtDlvLv: 'Liegt dem DLV und LV vor',
		reloading: 'Laden...',
		register: 'Registreren',
		registerTitle: 'Registreren',
		registerButton: 'Registreren',
		registrationSuccess: 'Bedankt voor uw registratie. Bevestig de e-mail die naar u is verzonden.',
		relayMembers: 'Estafette deelnemer',
		resetPasswordTitle: 'Wachtwoord resetten',
		resetPasswordButton: 'Wachtwoord resetten',
		resetPasswordSuccess: 'Uw wachtwoord is succesvol opnieuw ingesteld. U kunt nu inloggen met uw nieuwe wachtwoord.',
		rejectRoleRequestTitle: 'Rolverzoek weigeren',
		rejectRoleReason: 'Reden',
		rejectButton: 'Afwijzen',
		role: 'Rol',
		roleRequestsTitle: 'Rolverzoeken',
		roleRequestsLoading: 'Laden, blijf wachten',
		rolerequests: 'Rolverzoek',
		removeRequestNotification: 'Weet je zeker dat je dat wilt verwijderen?',
		removeRoleButtonInfo: 'Rol verwijderen',
		removeRequestButtonInfo: 'Verzoek verwijderen',
		removeRole: 'Weet je zeker dat je dat wilt verwijderen?',
		removeLastRoles: 'Wil je echt alle rollen voor gebruikers verwijderen:',
		redirectPerfList: 'Directe link naar dit leaderboard',
		rejectRequestButtonInfo: 'Verzoek weigeren',
		regionalRestriction: 'Regionale-Einschränkung',
		reportingPortalLink: 'Link naar het registratieportaal',
		record: 'Record',
		onlyStartingPassAllowed: 'Mogen alleen startende pashouders deelnemen aan dit evenement?',
		save: 'Opslaan',
		save_and_send: 'Opslaan en verzenden naar...',
		spinner: 'Verwerken...',
		sortButton: 'Sorteren',
		setAge4All: 'Voor alle categorieën',
		send: 'Verzenden',
		search: 'Zoeken',
		searchButton: 'Zoeken',
		searchPeriod: 'Zoekperiode',
		stadionName: 'Accommodatie',
		startAge: 'Begin leeftijd',
		startDate: 'Startdatum',
		startTime: 'Starttijd',
		status: 'Status',
		statistic: 'Statistiek',
		stateCode: 'Postcode',
		streetNr: 'Huisnummer',
		street: 'Straat',
		stopEmails: 'Verzenden van e-mails onderdrukken',
		showDetails: 'Details bekijken',
		startLocation: 'Start locatie',
		stateAssociation: 'Landesverband',
		startTypingSearch: 'Als u binnenkomt, wordt de zoekopdracht gestart',
		sum: 'Som',
		sumOverAll: 'Totaal',
		toLong: 'Invoer te lang. Gelieve in te korten.',
		title: 'Titel',
		timeFormat: 'uu:mm',
		to: 'tot',
		till: 'tot',
		town: 'Stad',
		type: 'Type',
		tootltipZeroIsinfinity: '0 (nul) = onbeperkt',
		unlimited: 'Onbeperkt',
		undecided: 'Nog niet bewerkt',
		userManagementTitle: 'Gebruikersadministratie',
		userManagementLoading: 'Laden even geduld aub',
		updateRoleButtonInfo: 'Rol bijwerken',
		updateBestListTitle: 'Scorebord bewerken',
		updatePerformanceTitle: 'Prestaties bewerken',
		updateCompetitionTitle: 'Wedstrijd bewerken',
		usermanagement: 'Gebruikersadministratie',
		user: 'Gebruiker',
		updateButton: 'Updaten',
		unsavedData: 'Gegevens zijn gewijzigd. Deze gaan verloren als u niet opslaat. Wil je verder gaan?',
		unknowen: 'Onbekend',
		yesButton: 'Ja',
		yob: 'Maand',
		year: 'Jaar',
		windResult: 'Windresultaat',
		jobpagesize: 'Aantal resultaten',
		jobyear: 'Jaar export',
		exportBestListTitle: 'Ranglijsten exporteren',
		exportButton: 'Exporteren starten',
		exportPerfList: 'Exporteren',
	},
};
